import React from "react";
import styled from "styled-components";
import { FaTimes } from "react-icons/fa";
import Cart from "../Cart/Cart";
import { useStore } from "../../store/useStore";

interface DrawerProps {
  open: boolean;
}
const CartDrawerWrapper = styled.div<DrawerProps>`
  position: fixed;
  top: 0;
  right: 0;
  width: 370px;
  height: 100vh;
  background: #fff;
  box-shadow: -2px 0 16px rgba(233, 125, 125, 0.13);
  z-index: 2001;
  display: flex;
  flex-direction: column;
  transition: transform 0.45s cubic-bezier(0.4, 1.2, 0.6, 1);
  transform: translateX(${(props) => (props.open ? "0" : "100%")});
`;
const CloseBtn = styled.button`
  position: absolute;
  top: 1.1rem;
  right: 1.1rem;
  background: none;
  border: none;
  font-size: 1.7rem;
  color: #e97d7dff;
  cursor: pointer;
  z-index: 10;
  transition: color 0.2s;
  &:hover {
    color: #000;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.18);
  z-index: 2000;
`;

const CartDrawer: React.FC = () => {
  const { cartOpen, setCartOpen } = useStore();
  return (
    <>
      {cartOpen && <Backdrop onClick={() => setCartOpen(false)} />}
      <CartDrawerWrapper open={cartOpen}>
        <CloseBtn onClick={() => setCartOpen(false)} aria-label="Close cart">
          {FaTimes({}) as React.ReactElement}
        </CloseBtn>
        <Cart />
      </CartDrawerWrapper>
    </>
  );
};

export default CartDrawer;
